<template>
    <!-- 多项选择 -->
    <div class="itemConte">
        <h5>{{itmData.questionindex}}.<span v-html="itmData.subject"></span>（{{itmData.questiontypename+'，'+itmData.quesscore}}分）</h5>
        <div class="resBox">
            <div class="res" v-for="(itm,idx) in itmData.optioninfo" :key="idx">
                <el-checkbox disabled v-model="itm.hasChoose" >{{itm.optionsvalue + itm.optioncontent}}</el-checkbox>
            </div>
        </div>
        <div class="resAns">
            <p>学员答案：{{itmData.uselanswer}}<span class="ans">答案{{itmData.answerstatus === 1 ? '正确':'错误'}}</span></p>
            <p>正确答案：{{itmData.optioninfo | ansStr}}</p>
            <p v-if="itmData.quesanalysis" class="analysis">解析：<span v-html="itmData.quesanalysis"></span></p>
            <p v-else class="analysis">解析：暂无解析</p>
        </div>
    </div>
</template>
<script>
export default {
    props: ['itmData'],
    data(){
        return {

        }
    },
    filters: {
        ansStr(ansData){
            let str = ''
            ansData.forEach(itm => {
                // str = str + itm
                if(itm.isrightanswer == 1){
                    str = str + itm.optionsvalue
                }
            })
            return str
        }
    },
    methods: {
        
    }
}
</script>